import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features51.css'

const Features51 = (props) => {
  return (
    <div
      className={`features51-layout223 thq-section-padding ${props.rootClassName} `}
    >
      <div className="features51-section-title thq-flex-column">
        <h2 className="thq-heading-2">
          {props.sectionTitle ?? (
            <Fragment>
              <span className="features51-text18">Our Solution</span>
            </Fragment>
          )}
        </h2>
        <p className="thq-body-large">
          {props.sectionDescription ?? (
            <Fragment>
              <span className="features51-text19">
                Discover the innovative features that set Signbridge AI apart in
                revolutionizing accessibility.
              </span>
            </Fragment>
          )}
        </p>
      </div>
      <div className="features51-container1">
        <div className="features51-max-width thq-section-max-width thq-flex-row">
          <div className="features51-container2 thq-flex-column"></div>
          <img
            alt={props.featureImageAlt}
            src={props.featureImageSrc}
            className="features51-placeholder-image thq-img-ratio-4-3"
          />
          <div className="thq-flex-column">
            <div className="features51-list thq-flex-column">
              <div className="thq-flex-row features51-list-item1">
                <img
                  alt={props.feature2ImageAlt}
                  src={props.feature2ImageSrc}
                  className="features51-image1 thq-team-image-round"
                />
                <div className="features51-content2 thq-flex-column">
                  <h3 className="thq-heading-3 features51-title2">
                    {props.feature2Description1 ?? (
                      <Fragment>
                        <span className="features51-text14">
                          Discover the Power of Actions
                        </span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-small features51-description2">
                    {props.feature2Description ?? (
                      <Fragment>
                        <span className="features51-text13">Prop Content</span>
                      </Fragment>
                    )}
                  </span>
                </div>
              </div>
              <div className="thq-flex-row features51-list-item2">
                <img
                  alt={props.feature3ImageAlt}
                  src={props.feature3ImageSrc}
                  className="features51-image2 thq-team-image-round"
                />
                <div className="features51-content3 thq-flex-column">
                  <h3 className="thq-heading-3 features51-title3">
                    {props.feature3Title ?? (
                      <Fragment>
                        <span className="features51-text17">Prop Content</span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-small features51-description3">
                    {props.feature3Description ?? (
                      <Fragment>
                        <span className="features51-text16">Prop Content</span>
                      </Fragment>
                    )}
                  </span>
                </div>
              </div>
              <div className="thq-flex-row">
                <img
                  alt={props.feature1ImageAlt}
                  src={props.feature1ImageSrc}
                  className="features51-image3 thq-team-image-round"
                />
                <div className="features51-content4 thq-flex-column">
                  <h3 className="thq-heading-3 features51-title1">
                    {props.feature1Title ?? (
                      <Fragment>
                        <span className="features51-text12">Prop Content</span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-small features51-description1">
                    {props.feature1Description ?? (
                      <Fragment>
                        <span className="features51-text15">Prop Content</span>
                      </Fragment>
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="features51-actions thq-flex-row"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features51.defaultProps = {
  featureImageSrc:
    'https://images.unsplash.com/photo-1724697379312-78dbbe89f68e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQxMTU1NHw&ixlib=rb-4.0.3&q=80&w=1400',
  feature1Title: undefined,
  feature1ImageSrc:
    'https://images.unsplash.com/photo-1591621839477-83880c7ec521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNXw&ixlib=rb-4.0.3&q=80&w=200',
  feature1ImageAlt: 'Real-time Sign Language Translation',
  feature2Description: undefined,
  feature2Description1: undefined,
  feature1Description: undefined,
  featureImageAlt: 'PlaceholderImage1314',
  feature3ImageSrc:
    'https://images.unsplash.com/photo-1730367796069-f8272f5249bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNnw&ixlib=rb-4.0.3&q=80&w=200',
  feature3ImageAlt: 'Deaf Community Engagement',
  feature3Description: undefined,
  feature3Title: undefined,
  feature2ImageSrc:
    'https://images.unsplash.com/photo-1677447807174-60a70de4a63e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNnw&ixlib=rb-4.0.3&q=80&w=200',
  feature2ImageAlt: 'VR/AR Integration',
  sectionTitle: undefined,
  sectionDescription: undefined,
  rootClassName: '',
}

Features51.propTypes = {
  featureImageSrc: PropTypes.string,
  feature1Title: PropTypes.element,
  feature1ImageSrc: PropTypes.string,
  feature1ImageAlt: PropTypes.string,
  feature2Description: PropTypes.element,
  feature2Description1: PropTypes.element,
  feature1Description: PropTypes.element,
  featureImageAlt: PropTypes.string,
  feature3ImageSrc: PropTypes.string,
  feature3ImageAlt: PropTypes.string,
  feature3Description: PropTypes.element,
  feature3Title: PropTypes.element,
  feature2ImageSrc: PropTypes.string,
  feature2ImageAlt: PropTypes.string,
  sectionTitle: PropTypes.element,
  sectionDescription: PropTypes.element,
  rootClassName: PropTypes.string,
}

export default Features51
